<ef-loading [loading]="loading"></ef-loading>
<div class="scroll-container card" fullscreen>
    <!-- main content-->
    <div>
        <div class="grid tab-view">
            <div class="flex items-center gap-2 col-12 grid">
                <button
                    class="tab-button col-fixed"
                    pButton
                    (click)="setType(0, $event)"
                    label="My Requests"
                    [ngClass]="{
                        active: leaveType === 0,
                        inactive: leaveType !== 0,
                        hidden: process?.ProcessID !== 69
                    }"
                ></button>
                <button
                    *ngIf="
                        (userInfo?.RoleGroupID === UserRoleEnum.Supervisor ||
                            userInfo?.RoleGroupID ===
                                UserRoleEnum.Administrator) &&
                        process?.ProcessID === 153
                    "
                    class="tab-button col-fixed"
                    icon="pi pi-inbox"
                    iconPos="left"
                    pButton
                    (click)="setType(1, $event)"
                    label="Requests Pending Action"
                    [ngClass]="{
                        active: leaveType === 1,
                        inactive: leaveType !== 1
                    }"
                ></button>
                <button
                    *ngIf="
                        (userInfo?.RoleGroupID === UserRoleEnum.Supervisor ||
                            userInfo?.RoleGroupID ===
                                UserRoleEnum.Administrator) &&
                        process?.ProcessID === 153
                    "
                    class="tab-button col-fixed"
                    icon="pi pi-undo"
                    iconPos="left"
                    pButton
                    (click)="setType(3, $event)"
                    label="Disapproved Requests"
                    [ngClass]="{
                        active: leaveType === 3,
                        inactive: leaveType !== 3
                    }"
                ></button>
                <button
                    *ngIf="
                        (userInfo?.RoleGroupID === UserRoleEnum.Supervisor ||
                            userInfo?.RoleGroupID ===
                                UserRoleEnum.Administrator) &&
                        process?.ProcessID === 153
                    "
                    class="tab-button col-fixed"
                    icon="pi pi-check"
                    iconPos="left"
                    pButton
                    (click)="setType(2, $event)"
                    label="Approved Requests"
                    [ngClass]="{
                        active: leaveType === 2,
                        inactive: leaveType !== 2
                    }"
                ></button>
                <span class="col">
                    <span
                        class="link-color-text"
                        style="float: right; font-weight: bold"
                    >
                        <span
                            [hidden]="!LeaveUser"
                            style="text-transform: uppercase"
                        >
                            {{ LeaveUser }}
                        </span>
                        <span [hidden]="!AccrualInfo">: {{ AccrualInfo }}</span>
                    </span>
                </span>
            </div>
            <div class="tab-panel grid col-12">
                <div
                    class="col-12 sm:col-12 md:col-12 lg:col-5"
                    style="overflow: auto"
                >
                    <div id="calendar-container" class="table-container">
                        <ef-fullcalendar
                            #calendar
                            id="calLeaveRequests"
                            [events]="events"
                            [options]="options"
                            (select)="datesSelected($event)"
                            (eventClick)="eventSelected($event)"
                            (datesRender)="datesRender($event)"
                            (eventRender)="eventRender($event)"
                        ></ef-fullcalendar>
                    </div>
                </div>

                <div class="col-12 sm:col-12 md:col-12 lg:col-7">
                    <div [hidden]="this.leaveType === 0">
                        <p-toolbar>
                            <button
                                #approveLeave
                                pButton
                                aria-label="Approve"
                                [hidden]="
                                    !(
                                        this.leaveType === 1 ||
                                        this.leaveType === 3
                                    )
                                "
                                label="Approve"
                                [disabled]="this.leaveSelectedCount === 0"
                                (click)="approveRequests()"
                            ></button>
                            <button
                                #unapproveLeave
                                pButton
                                aria-label="Unapprove"
                                [hidden]="this.leaveType !== 2"
                                label="Unapprove"
                                [disabled]="this.leaveSelectedCount === 0"
                                (click)="unApproveRequests()"
                            ></button>
                            <button
                                #disapproveLeave
                                pButton
                                aria-label="Disapprove"
                                [hidden]="this.leaveType !== 1"
                                label="Disapprove"
                                [disabled]="this.leaveSelectedCount === 0"
                                (click)="showDisapprovePopup = true"
                            ></button>
                        </p-toolbar>
                    </div>
                    <div>
                        <p-table stripedRows #dtLeaveRequests
                            [value]="leaverequests"
                            tableStyleClass="table"
                            dataKey="AuthRequestID"
                            editMode="row"
                            [style]="{ 'min-width': '50em' }"
                            (onRowSelect)="onRowSelect($event)"
                            selectionMode="single"
                            [scrollable]="true"
                            scrollHeight="75vh"
                        >
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td
                                        [attr.colspan]="
                                            this.leaveType === 0 ? 8 : 10
                                        "
                                        style="text-align: center"
                                    >
                                        <div class="tabulator-placeholder">
                                            <span> No Data Available </span>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="loadingbody">
                                <tr>
                                    <td
                                        [attr.colspan]="
                                            this.leaveType === 0 ? 8 : 10
                                        "
                                        style="text-align: center"
                                    >
                                        <div>
                                            Loading...<i
                                                class="fa fa-spinner fa-spin"
                                            ></i>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template #header let-item>
                                <tr>
                                    <!-- Edit -->
                                    <th  class="edit-cell"></th>
                                    <!-- Status -->
                                    <th class="status-cell">
                                        <div
                                            style="
                                                margin-bottom: 0.75em;
                                                margin-left: 0.25em;
                                            "
                                        >
                                            <i
                                                class="pi pi-exclamation-circle"
                                                title="Status"
                                            ></i>
                                        </div>
                                    </th>
                                    <!-- Select -->
                                    <th class="select-cell" *ngIf="this.leaveType !== 0"></th>
                                    <!-- Leave Status -->
                                    <th class="small-cell">
                                        Status
                                        <p-sortIcon
                                            pSortableColumn="RequestStatus"
                                            field="RequestStatus"
                                            ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order"
                                        ></p-sortIcon>
                                        <p-columnFilter field="RequestStatus" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                            [showAddButton]="false" class="ml-auto">
                                            <ng-template #filter let-value let-filter="filterCallback">
                                                <p-multiSelect
                                                    [virtualScroll]="true"
                                                    itemSize="32"
                                                    defaultLabel="Filter"
                                                    maxSelectedLabels="1"
                                                    appendTo="body"
                                                    [options]="RequestStatusSelectItems"
                                                    [filter]="true"
                                                    styleClass="w-full"
                                                    [ngModel]="value"
                                                    (ngModelChange)="filter($event)"
                                                ></p-multiSelect>
                                            </ng-template>
                                        </p-columnFilter>
                                    </th>
                                    <!-- Employee -->
                                    <th class="large-cell" *ngIf="this.leaveType !== 0">
                                        Employee
                                        <p-sortIcon
                                            pSortableColumn="Task"
                                            field="Task"
                                            ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order"
                                        ></p-sortIcon>
                                    </th>
                                    <!-- Task -->
                                    <th class="large-cell">
                                        Task
                                        <p-sortIcon
                                            pSortableColumn="Task"
                                            field="Task"
                                            ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order"
                                        ></p-sortIcon>
                                        <p-columnFilter field="TaskListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                            [showAddButton]="false" class="ml-auto">
                                            <ng-template #filter let-value let-filter="filterCallback">
                                                <p-multiSelect
                                                    [virtualScroll]="true"
                                                    itemSize="32"
                                                    defaultLabel="Filter"
                                                    maxSelectedLabels="1"
                                                    appendTo="body"
                                                    [options]="taskSelectItems"
                                                    [filter]="true"
                                                    styleClass="w-full"
                                                    [ngModel]="value"
                                                    (ngModelChange)="filter($event)"
                                                ></p-multiSelect>
                                            </ng-template>
                                        </p-columnFilter>
                                    </th>
                                    <!-- Payroll Item -->
                                    <th *ngIf="createAuthSetting" class="small-cell">
                                        Payroll Item
                                    </th>
                                    <!-- Service Item -->
                                    <th *ngIf="createAuthSetting" class="small-cell">
                                        Service Item
                                    </th>
                                    <!-- Date -->
                                    <th class="medium-cell">
                                        Date
                                        <p-sortIcon
                                            pSortableColumn="EmpAuthStartDate"
                                            field="EmpAuthStartDate"
                                            ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order"
                                        ></p-sortIcon>
                                        <p-columnFilter type="date" field="EmpAuthStartDate" display="menu" class="ml-auto" />
                                    </th>
                                    <!-- Description -->
                                    <th class="large-cell">
                                        Description
                                        <p-sortIcon
                                            pSortableColumn="AuthDesc"
                                            field="AuthDesc"
                                            ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order"
                                        ></p-sortIcon>
                                        <p-columnFilter type="text" matchMode="contains" field="AuthDesc" display="menu" class="ml-auto" />
                                    </th>
                                    <!-- Hours -->
                                    <th class="small-cell">
                                        Hours
                                    </th>
                                    <!-- Delete -->
                                    <th class="delete-cell"></th>
                                </tr>
                            </ng-template>
                            <ng-template
                                #body
                                let-item
                                let-edit="editing"
                            >
                                <tr
                                    [pSelectableRow]="item"
                                    [pEditableRow]="item"
                                    [ngClass]="{
                                        'ui-editing-row':
                                            edit &&
                                            editing?.AuthRequestID ===
                                                item?.AuthRequestID
                                    }"
                                    data-id="row-{{ item.AuthRequestID }}"
                                >
                                    <!-- Edit -->
                                    <td class="edit-cell">
                                        <button
                                            *ngIf="
                                                isLeaveEditable(item) &&
                                                !edit &&
                                                (!editing?.AuthRequestID ||
                                                    editing?.AuthRequestID ===
                                                        item?.AuthRequestID)
                                            "
                                            pButton
                                            type="button"
                                            pInitEditableRow
                                            icon="pi pi-pencil"
                                            rounded
                                            text
                                            (click)="onRowEditInit(item)"
                                            title="Edit"
                                        ></button>
                                        <button
                                            *ngIf="isLeaveEditable(item) && edit"
                                            pButton
                                            type="button"
                                            pSaveEditableRow
                                            icon="pi pi-check"
                                            rounded
                                            text
                                            severity="success"
                                            (click)="onRowEditSave(item)"
                                        ></button>
                                        <button
                                            *ngIf="isLeaveEditable(item) && edit"
                                            pButton
                                            type="button"
                                            pCancelEditableRow
                                            icon="pi pi-times"
                                            rounded
                                            text
                                            severity="danger"
                                            (click)="onRowEditCancel(item)"
                                        ></button>
                                    </td>
                                    <!-- Status -->
                                    <td class="status-cell">
                                        <div
                                            (click)="onStatusClick(item)"
                                            class="status-cell"
                                        >
                                            <ef-status-icon
                                                [status]="
                                                    item?.Status?.StatusCode
                                                "
                                                [message]="
                                                    item?.Status?.Message
                                                "
                                            ></ef-status-icon>
                                        </div>
                                    </td>
                                    <!-- Select  -->
                                    <td
                                        class="select-cell"
                                        *ngIf="this.leaveType !== 0"
                                    >
                                        <div>
                                            <p-checkbox
                                                binary="true"
                                                [(ngModel)]="item.selected"
                                            ></p-checkbox>
                                        </div>
                                    </td>
                                    <!-- Leave Status -->
                                    <td class="small-cell">
                                        {{ item?.RequestStatus }}
                                    </td>
                                    <!-- Employee -->
                                    <td
                                        [ngClass]="{
                                            disabled: item.IsReadOnly
                                        }"
                                        class="large-cell disabled"
                                        *ngIf="this.leaveType !== 0"
                                    >
                                        {{
                                            (
                                                directReports
                                                | itemlookup
                                                    : 'EmployeeListID'
                                                    : item?.EmployeeListID
                                            )?.EmployeeName
                                        }}
                                    </td>
                                    <!-- Task -->
                                    <td
                                        [ngClass]="{
                                            disabled: item.IsReadOnly
                                        }"
                                        class="large-cell"
                                    >
                                        <p-cellEditor>
                                            <ng-template

                                                pTemplate="input"
                                            >
                                                <p-dropdown
                                                    (onChange)="onTaskChanged(item)"
                                                    [style]="{ width: '100%' }"
                                                    [virtualScroll]="true"
                                                    itemSize="32"
                                                    *ngIf="
                                                        tasks as items;
                                                    "
                                                    [options]="
                                                        taskSelectItems
                                                            | orderBy: 'label'
                                                    "
                                                    appendTo="body"
                                                    [(ngModel)]="
                                                        item.TaskListID
                                                    "
                                                    defaultLabel="Tasks"
                                                    [filter]="true"
                                                ></p-dropdown>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{
                                                    (
                                                        tasks
                                                        | itemlookup
                                                            : 'TaskListID'
                                                            : item?.TaskListID
                                                    )?.TaskLongName
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <!-- Payroll Item -->
                                    <td
                                        *ngIf="createAuthSetting"
                                        class="small-cell"
                                    >
                                        <p-cellEditor>
                                            <ng-template
                                                *ngIf="payrollItemEditable"
                                                pTemplate="input"
                                            >
                                                <p-dropdown
                                                    (onChange)="onPayrollItemChanged($event)"
                                                    [style]="{ width: '100%' }"
                                                    [virtualScroll]="true"
                                                    itemSize="32"
                                                    *ngIf="payrollItems as items;"
                                                    [options]="payrollItemSelectItems"
                                                    appendTo="body"
                                                    [(ngModel)]="selectedPayrollItem"
                                                    defaultLabel="Payroll Items"
                                                    [filter]="true"
                                                ></p-dropdown>
                                            </ng-template>
                                            <ng-template *ngIf="payrollItemEditable == false" pTemplate="input">
                                                {{
                                                    (
                                                        payrollItems
                                                        | itemlookup
                                                            : 'PIListID'
                                                            : item?.PIListID
                                                    )?.PayrollItem
                                                }}
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{
                                                    (
                                                        payrollItems
                                                        | itemlookup
                                                            : 'PIListID'
                                                            : item?.PIListID
                                                    )?.PayrollItem
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <!-- Service Item -->
                                    <td
                                    *ngIf="createAuthSetting"
                                        class="small-cell"
                                    >
                                        <p-cellEditor>
                                            <ng-template
                                                *ngIf="payrollItemEditable"
                                                pTemplate="input"
                                            >
                                                <p-dropdown
                                                    [style]="{ width: '100%' }"
                                                    [virtualScroll]="true"
                                                    itemSize="32"
                                                    *ngIf="serviceItems as items;"
                                                    [options]="serviceItemSelectItems"
                                                    appendTo="body"
                                                    [(ngModel)]="item.SIListID"
                                                    defaultLabel="Service Items"
                                                    [filter]="true"
                                                ></p-dropdown>
                                            </ng-template>
                                            <ng-template *ngIf="payrollItemEditable == false" pTemplate="input">
                                                {{
                                                    (
                                                        serviceItems
                                                        | itemlookup
                                                            : 'SIListID'
                                                            : item?.SIListID
                                                    )?.ServiceItem
                                                }}
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{
                                                    (
                                                        serviceItems
                                                        | itemlookup
                                                            : 'SIListID'
                                                            : item?.SIListID
                                                    )?.ServiceItem
                                                }}
                                            </ng-template>
                                        </p-cellEditor>

                                    </td>
                                    <!-- Date -->
                                    <td
                                        [ngClass]="{
                                            disabled: item.IsReadOnly
                                        }"
                                        class="medium-cell"
                                    >
                                        <p-cellEditor>
                                            <ng-template

                                                pTemplate="input"
                                            >
                                                <p-calendar
                                                    #leaveDates
                                                    [(ngModel)]="item.dates"
                                                    [appendTo]="calendarWrapper"
                                                    [readonlyInput]="true"
                                                    dateFormat="mm/dd/yy"
                                                    selectionMode="range"
                                                    [yearNavigator]="true"
                                                    [monthNavigator]="true"
                                                    yearRange="2010:2030"
                                                >
                                                </p-calendar>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{
                                                    moment(
                                                        item?.EmpAuthStartDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                                -
                                                {{
                                                    moment(
                                                        item?.EmpAuthEndDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <!-- Description -->
                                    <td
                                        [ngClass]="{
                                            disabled: item.IsReadOnly
                                        }"
                                        class="large-cell"
                                    >
                                        <p-cellEditor>
                                            <ng-template

                                                pTemplate="input"
                                            >
                                                <input
                                                    pInputText
                                                    [(ngModel)]="item.AuthDesc"
                                                />
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ item?.AuthDesc }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <!-- Hours -->
                                    <td
                                        [ngClass]="{
                                            disabled: item.IsReadOnly
                                        }"
                                        class="small-cell"
                                    >
                                        <p-cellEditor>
                                            <ng-template

                                                pTemplate="input"
                                            >
                                                <input
                                                    pInputText
                                                    [(ngModel)]="
                                                        item.RequestHours
                                                    "
                                                />
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{ item?.RequestHours }}
                                            </ng-template>
                                        </p-cellEditor>
                                    </td>
                                    <!-- Delete -->
                                    <td class="delete-cell">
                                        <button
                                            *ngIf="isLeaveEditable(item)"

                                            pButton
                                            type="button"
                                            icon="pi pi-trash"
                                            class="
                                                p-button-danger
                                                p-button-rounded
                                                p-button-text
                                            "
                                            (click)="onDelete(item)"
                                            style="font-size: 1rem"
                                        ></button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div #calendarWrapper stop-click-propagation>
    <p-dialog
        #leaveRequestDialog
        header="Leave Request Details"
        [(visible)]="showPopup"
        [maximizable]="false"
        [modal]="true"
        appendTo="body"
        [style]="{ 'min-width': '275px' }"
    >
        <form [formGroup]="newRequestForm" #requestForm *ngIf="showPopup">
            <input type="hidden" formControlName="AuthRequestID" />
            <p-floatLabel variant="on" class="mb-3 mt-2">
                <p-calendar
                    #dateFilter
                    inputId="filterDate"
                    inputStyleClass="clearable-date-filter p-inputtext"
                    styleClass="w-full"
                    [hideOnDateTimeSelect]="true"
                    [(ngModel)]="dates"
                    [ngModelOptions]="{ standalone: true }"
                    appendTo="body"
                    selectionMode="range"
                    [readonlyInput]="false"
                    dateFormat="mm/dd/yy"
                    [yearNavigator]="true"
                            [monthNavigator]="true"
                            yearRange="2010:2030"
                >
                </p-calendar>
                <label>Dates</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3">
                <p-select
                    [virtualScroll]="true"
                    itemSize="32"
                    *ngIf="tasks as items"
                    [options]="items"
                    optionLabel="TaskLongName"
                    appendTo="body"
                    formControlName="task"
                    defaultLabel="Tasks"
                    dataKey="TaskListID"
                    [filter]="true"
                    styleClass="w-full"
                ></p-select>
                <label>Tasks</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3">
                <input
                    pInputText
                    formControlName="RequestHours"
                    class="w-full"
                />
                <label>Hours Requested</label>
            </p-floatLabel>
            <p-floatLabel variant="on">
                <textarea
                    pInputTextarea
                    class="w-full"
                    formControlName="AuthDesc"
                ></textarea>
                <label>Comments</label>
            </p-floatLabel>
        </form>
        <ng-template #footer >
            <button
                type="button"
                pButton
                pRipple
                label="Cancel"
                (click)="Cancel()"
                text
                severity="danger"
            ></button>
            <button
                id="btnSave"
                type="submit"
                pButton
                pRipple
                label="Save"
                (click)="onSave(this.newRequestForm.value)"
                text
                severity="success"
            ></button>
        </ng-template>
    </p-dialog>

    <p-dialog
        #disapproveLeaveRequestDialog
        header="Disapprove Leave Request"
        [(visible)]="showDisapprovePopup"
        [maximizable]="false"
        [modal]="true"
        appendTo="body"
        [style]="{ 'min-width': '275px' }"
    >
        <p-floatLabel variant="on" class="mb-3">
            <textarea
                pInputTextarea
                class="w-full"
                [(ngModel)]="disapproveComment"
            ></textarea>
            <label>Comments</label>
        </p-floatLabel>
        <ng-template #footer >
            <button
                type="button"
                pButton
                pRipple
                label="Cancel"
                (click)="cancelDisapprove()"
                text
            ></button>
            <button
                id="btnDisapprove"
                type="submit"
                pButton
                pRipple
                label="Disapprove"
                (click)="disApproveRequests()"
                text
                severity="danger"
            ></button>
        </ng-template>
    </p-dialog>
</div>
